<template>
  <div>
    <div class="header">
      <span class="iconfont icon-left return" @click="returnBack"></span>
      <div class="modifyPsd">
        <span>初始密码修改</span>
      </div>
    </div>
    <logo></logo>
    <div class="content">
      <div class="errowShow" v-if="isShow">{{tishi}}</div>
      <div class="form-group">
        <label class="login_label">帐号</label>
        <input  for="username" type="text"  class="account inputForm" :value="account" disabled="disabled" style="background: none;"/>
      </div>
      <div class="form-group">
        <label class="login_label">旧密码</label>
        <input  for="username" :type="textThree"  class="account inputForm" style="background: none;" placeholder="请输入旧密码" v-model="oldPassword"/>
        <!--<span class="iconfont icon-yiyun togglePsd" @click="togglePsdThree"></span>-->
        <img :src="changePsdthree" class="togglePsd" style="top: 0.25rem; width: 0.4rem;height: 0.4rem;" @click="togglePsdThree"/>
      </div>
      <div class="form-group">
        <label class="login_label">新密码</label>
        <input  for="username" :type="textOne" placeholder="请输入8位以上数字字母特殊符号组合"
                class="account inputForm"
                v-model="newPassword" @blur="changeNewpassword"
                @focus="focusNewpassword"  maxlength="16">
        <!--<span class="iconfont icon-yiyun togglePsd" @click="togglePsdOne"></span>-->
        <img :src="changePsdone" class="togglePsd" style="top: 0.25rem; width: 0.4rem;height: 0.4rem;" @click="togglePsdOne"/>
      </div>
      <div class="form-group">
        <label class="login_label">新密码</label>
        <input  for="username" :type="textTwo" placeholder="请再次输入新密码" class="account inputForm"
                v-model="confirm_password" v-on:mousedown="focusConfirmpassword"
                maxlength="16">
        <!--<span class="iconfont icon-yiyun togglePsd" @click="togglePsdTwo"></span>-->
        <img :src="changePsdtwo" class="togglePsd" style="top: 0.25rem; width: 0.4rem;height: 0.4rem;" @click="togglePsdTwo"/>
      </div>
      <div style="padding: 0.4rem 0.4rem 0">
        <mt-button type="primary" size="large" class="btn" @click="finsh">完成</mt-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Logo from '../../common/logo'
  import cloudApi from '../../apis/cloudStorageApi'
  import apis from '../../apis/index'
  import crypto from '@/utils/crypto'

  export default {
    name: 'modifyPassword',
    components: {Logo},
    data () {
      return {
        changePsdone: require('../../assets/images/changePsd.png'),
        changePsdtwo: require('../../assets/images/changePsd.png'),
        changePsdthree: require('../../assets/images/changePsd.png'),
        account: '',
        textOne: 'password',
        textTwo: 'password',
        textThree: 'password',
        isShow: false,
        tishi: '',
        oldPassword: '',
        newPassword: '',
        confirm_password: ''
      }
    },
    created () {
      this.account = this.$route.query.account
    },
    methods: {
      togglePsdOne () {
        this.textOne = this.textOne === 'text' ? 'password' : 'text'
        this.changePsdone = this.textOne === 'text' ? require('../../assets/images/changePsd1.png') : require('../../assets/images/changePsd.png')
      },
      togglePsdTwo () {
        this.textTwo = this.textTwo === 'text' ? 'password' : 'text'
        this.changePsdtwo = this.textTwo === 'text' ? require('../../assets/images/changePsd1.png') : require('../../assets/images/changePsd.png')
      },
      togglePsdThree () {
        this.textThree = this.textThree === 'text' ? 'password' : 'text'
        this.changePsdthree = this.textThree === 'text' ? require('../../assets/images/changePsd1.png') : require('../../assets/images/changePsd.png')
      },
      returnBack () {
        this.$router.push({path: '/login'})
      },
      changeNewpassword () {
        var reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!-\/:-@\[-`{-~])[!-~]{8,20}$/
        var _this = this
        if (_this.newPassword.length === 0) {
          _this.isShow = true
          _this.tishi = '密码不能为空'
          return false
        }
        if (_this.newPassword.length < 6) {
          _this.isShow = true
          _this.tishi = '密码长度不能小于6个字符'
          return false
        }
        if (_this.newPassword.length > 16) {
          _this.isShow = true
          _this.tishi = '密码长度不能大于16个字符'
          return false
        }
        if (!reg.test(_this.newPassword)) {
          _this.isShow = true
          _this.tishi = '密码必须是8-16位字母、数字和符号三种组合'
          return false
        }
      },
      focusNewpassword () {
        this.isShow = false
      },
      focusConfirmpassword () {
        this.isShow = false
        if (this.oldPassword !== '' && this.newPassword !== '') {
        }
      },
      finsh () {
        const validate = this.changeNewpassword()
        if (validate === false) {
          return validate
        }
        if (!this.oldPassword) {
          this.isShow = true
          this.tishi = '请输入旧密码'
          window.setTimeout(() => {
            this.isShow = false
          }, 2000)
        }
        if (this.oldPassword !== '' && this.newPassword !== '') {
          this.isA = false
          if (this.confirm_password.trim() === '') {
            this.isShow = true
            this.tishi = '请输入新密码'
            return false
          }
          if (this.confirm_password !== this.newPassword) {
            this.isShow = true
            this.tishi = '两次密码输入不一致'
            return false
          } else {
            this.isShow = false
            var oldPassword = this.oldPassword
            var value = this.newPassword
            var _this = this
            apis.request(cloudApi.info, {value: crypto.Encrypt(value), type: 4, oldPassword: crypto.Encrypt(oldPassword)}).then(function (response) {
              let instance = Toast({
                message: '修改成功',
                iconClass: 'icon-success',
                duration: 1500
              })
              _this.oldPassword = ''
              _this.newPassword = ''
              _this.confirm_password = ''
              _this.isshow = true
              _this.isA = true
              setTimeout(() => {
                instance.close()
                apis.request(cloudApi.logout, {}).then(function () {
                  sessionStorage.removeItem('mobileData')
                  // window.localStorage.clear()
                  // _this.$router.push('/login')
                  _this.$router.push({path: '/login'})
                })
              }, 1500)
            }).catch(function (error) {
              Toast({
                message: error.response.data.message,
                iconClass: 'icon-error'
              })
              _this.oldPassword = ''
              _this.isA = true
            })
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/variable";
.header {
  width: 100%;
  height: 1.28rem;
  background: #44474D;
  font-family: PingFangSC-Semibold;
  color: #FFFFFF;
  font-size: $fontsize-lg;
  line-height: 1.28rem;

  .return {
    /*display: inline-block;*/
    font-size: .4rem;
    position: absolute;
    left: .16rem;
  }
  .modifyPsd {
    /*margin-right: 2.72rem;*/
    display: -webkit-flex;
    display: flex;
    justify-content: space-around;
  }
}
.top {
  background-color: #ecf0f3;
  padding-bottom: .6rem;
  font-size: .36rem;
  text-align: center;
  color: #666666;
}
.content {
  .form-group {
    background-color: #ffffff;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    height: .88rem;
    line-height: .88rem;
    box-sizing: border-box;
    overflow: hidden;
    /*padding: 0.05rem;*/
    padding: 0 .3rem;

    .login_label {
      color: #000000;
      font-size: .36rem;
      width: 1.54rem;
      text-align: left;
      display: inline-block;
    }

    .inputForm {
      display: inline-block;
      font-size: .36rem;
      border: 0;
      border-radius: 0;
      position: absolute;
      top: .19rem;
      outline: 0;
      color: #1D1F22;
    }
    .togglePsd {
      color: #707172;
      position: absolute;
      right: 0.32rem;
      font-size: 0.6rem;
    }
  }
  .errowShow {
    width: 100%;
    position: absolute;
    top: 1.28rem;
    bottom: 0;
    left: 0;
    right: 0;
    height: .7rem;
    background: $white;
    font-size: .3rem;
    color: $theme-color;
    text-align: center;
    line-height: .5rem;
    padding: .1rem 0;
    box-shadow: $box-shadow-base;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/modifyPassword/modifyPassword.vue